import { selectMaintainProject, insertMaintainProject, updateMaintainProject, deleteMaintainProject, selectProject, selectTreeFormProject } from "../../api/config/modules/MaintenanceProgram";

const state = {
    selectMaintainProject: {},
    insertMaintainProject: {},
    updateMaintainProject: {},
    deleteMaintainProject: {},
    selectProject: {},
    selectTreeFormProject: {}
};

const mutations = {
    SET_SELECTMAINTAINPROJECT: (state, selectMaintainProject) => {
        state.selectMaintainProject = selectMaintainProject;
    },
    SET_INSERTMAINTAINPROJECT: (state, insertMaintainProject) => {
        state.insertMaintainProject = insertMaintainProject;
    },
    SET_UPDATEMAINTAINPROJECT: (state, updateMaintainProject) => {
        state.updateMaintainProject = updateMaintainProject;
    },
    SET_DELETEMAINTAINPROJECT: (state, deleteMaintainProject) => {
        state.deleteMaintainProject = deleteMaintainProject;
    },
    SET_SELECTPROJECT: (state, selectProject) => {
        state.selectProject = selectProject;
    },
    SET_SELECTTREEFORMPROJECT: (state, selectTreeFormProject) => {
        state.selectTreeFormProject = selectTreeFormProject;
    },
};

const actions = {
    GET_SELECTMAINTAINPROJECT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectMaintainProject(data)
                .then((res) => {
                    commit("SET_SELECTMAINTAINPROJECT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTMAINTAINPROJECT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertMaintainProject(data)
                .then((res) => {
                    commit("SET_INSERTMAINTAINPROJECT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEMAINTAINPROJECT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateMaintainProject(data)
                .then((res) => {
                    commit("SET_UPDATEMAINTAINPROJECT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEMAINTAINPROJECT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteMaintainProject(data)
                .then((res) => {
                    commit("SET_DELETEMAINTAINPROJECT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTPROJECT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectProject(data)
                .then((res) => {
                    commit("SET_SELECTPROJECT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTTREEFORMPROJECT: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectTreeFormProject(data)
                .then((res) => {
                    commit("SET_SELECTTREEFORMPROJECT", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
